// icon
import { IconUser, IconHeart, IconShoppingCart, IconPencil, IconCategory, IconAddressBook, IconHeadphones } from "@tabler/icons-react";
// components
import Profile from "../../pages/admin/profile/profile";
import WishList from "../../pages/admin/wishList/wishlist";
import Orders from "../../pages/admin/orders/orders";
import Comments from "../../pages/admin/comments/comments";
import ProfileEdit from "../../pages/admin/profileEdit/profileEdit";
import AddressUser from "../../pages/admin/address/addressUser";
import Ticket from "../../pages/admin/ticket/ticket";

export const RoutesUser = [
    {
        show: true,
        child: false,
        label: 'داشبورد',
        address: '/user/profile',
        component: <Profile />,
        icon: <IconCategory />,
    },
    {
        show: false,
        child: false,
        label: 'سفارشات',
        address: '/user/orders',
        component: <Orders />,
        icon: <IconShoppingCart />
    },
    {
        show: true,
        child: false,
        label: 'اطلاعات کاربری',
        address: '/user/detail',
        component: <ProfileEdit />,
        icon: <IconUser />,
    },
    {
        show: true,
        child: false,
        label: 'علاقه مندی ها',
        address: '/user/wishList',
        component: <WishList />,
        icon: <IconHeart />,
    },
    {
        show: true,
        child: false,
        label: 'نشانی',
        address: '/user/address',
        component: <AddressUser />,
        icon: <IconAddressBook />
    },
    {
        show: false,
        child: false,
        label: 'نظرات',
        address: '/user/comments',
        component: <Comments />,
        icon: <IconPencil />
    },
    {
        show: true,
        child: false,
        label: 'پشتیبانی',
        address: '/user/ticket',
        component: <Ticket />,
        icon: <IconHeadphones />
    },
]